<div class="alert alert-light fade show" [ngClass]="classes" role="alert">
	<div class="alert-icon">
		<i [ngClass]="icon"></i>
	</div>
	<div class="alert-text">
		<ng-content></ng-content>
	</div>
</div>
